// js
import React from 'react';
import PropTypes from 'prop-types';
import securityDashboardColors from '../../constants/securityDashboardColors';
// css
import '../../styles/components/common/GraduatedProgressChart.scss';


const SecurityDashboardProgressChart = ({
  title,
  dashboards
}) => {
  const formattedTitle = [
    title,
      [
        dashboards.filter(db => db.indexLevel === 'acceptable').length,
        dashboards.length
      ].join(' of ')
    ]
    .filter(part => part.length)
    .join(' - ');

  const segments = dashboards.sort((a, b) => b.indexPercent - a.indexPercent)
    .map((db, i) => (
      <div
        key={i}
        style={{ backgroundColor: securityDashboardColors[db.indexLevel] }}
        className='graduated-progress-chart__chart-segment' />
  ));

  return (
    <div className='graduated-progress-chart'>
      <div className='graduated-progress-chart__chart'>
        {segments}
      </div>
      <div className='graduated-progress-chart__title'>
        {formattedTitle}
      </div>
    </div>
  );
};

SecurityDashboardProgressChart.propTypes = {
  title: PropTypes.string.isRequired,
  dashboards: PropTypes.array.isRequired
};

export default SecurityDashboardProgressChart;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityDashboardProgressChart.js